import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Vehiculos';

export interface Vehiculo {
  vehiculo: string;
}

export class VehiculosAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarVehiculos(): AxiosPromise<Vehiculo[]> {
		return this.cliente.get(`/ListarVehiculos`);
	}
}